<template>
  <v-container class="py-8">
    <!-- Header -->
    <v-row>
      <v-col>
        <h1 class="text-h4 font-weight-bold">{{ t('promptmanagement.title') }}</h1>
        <p class="text-body-1 text-medium-emphasis mt-2">
          {{ t('promptmanagement.description') }}
        </p>
      </v-col>
    </v-row>

    <!-- Buttons -->
    <v-row justify="center" class="mt-8" style="min-height: 300px; align-items: center;">
      <!-- Question-driven -->
      <v-col cols="12" md="4">
        <v-card
          rounded="xl"
          variant="outlined"
          class="prompt-card pa-8"
          hover
          @click="$router.push({ name: 'prompt-management-question-driven' })"
        >
          <div class="d-flex justify-center mb-4">
            <div class="icon-bg icon-bg--blue">
              <v-icon size="72" color="#0D3B6E">mdi-help-circle-outline</v-icon>
            </div>
          </div>
          <h2 class="text-h5 font-weight-bold mb-3 text-center">{{ t('promptmanagement.questionDriven') }}</h2>
          <div class="d-flex align-center justify-center mt-2">
            <p class="text-body-2 text-medium-emphasis text-center mb-0">
              {{ t('promptmanagement.questionDrivenDescription') }}
            </p>
            <v-icon size="36" color="#0D3B6E" class="ml-2 flex-shrink-0">mdi-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>

      <!-- Template-based -->
      <v-col cols="12" md="4">
        <v-card
          rounded="xl"
          variant="outlined"
          class="prompt-card pa-8"
          hover
          @click="$router.push({ name: 'prompt-management-templates' })"
        >
          <div class="d-flex justify-center mb-4">
            <div class="icon-bg icon-bg--green">
              <v-icon size="72" color="#1B5E20">mdi-file-document-outline</v-icon>
            </div>
          </div>
          <h2 class="text-h5 font-weight-bold mb-3 text-center">{{ t('promptmanagement.templateBased') }}</h2>
          <div class="d-flex align-center justify-center mt-2">
            <p class="text-body-2 text-medium-emphasis text-center mb-0">
              {{ t('promptmanagement.templateBasedDescription') }}
            </p>
            <v-icon size="36" color="#1B5E20" class="ml-2 flex-shrink-0">mdi-chevron-right</v-icon>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { useI18n } from 'vue-i18n';

export default {
  name: 'PromptManagement',
  setup() {
    const { t } = useI18n();
    return { t };
  },
};
</script>

<style scoped>
.prompt-card {
  cursor: pointer;
  transition: box-shadow 0.2s ease, transform 0.2s ease;
  min-height: 220px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.prompt-card:hover {
  transform: translateY(-4px);
}

.icon-bg {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  padding: 20px;
}

.icon-bg--blue {
  background-color: #BBDEFB;
}

.icon-bg--green {
  background-color: #C8E6C9;
}
</style>
